
import UpdateWorker from "../../../components/@users/workers/UpdateWorker";

import { routeTypes } from "../../../hooks/useSystemRoutes";

export default function ProfilePage() {

    return (
        <UpdateWorker 
            routeType={routeTypes.workstation}
            isOwnProfile={Boolean(true)}
        />
    )
}       